import { CSSProperties } from 'react';

export const classificacaoGridStyle: CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 16,
  marginBottom: 24
};

export const labelStyle: CSSProperties = {
  display: 'block',
  marginBottom: 8,
  fontSize: 14,
  fontWeight: 500,
};

export const areaAverbadaSwitchStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  marginBottom: 12,
};

export const areaTitleStyle: CSSProperties = {
  fontSize: 16,
  fontWeight: 600,
  margin: 0,
  color: '#262626',
};

export const tableBorderStyle: CSSProperties = {
  border: '1px solid #d9d9d9',
  borderRadius: 8,
  overflow: 'hidden',
};

export const tableRowStyle: CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
};

export const tableRowWithBorderStyle: CSSProperties = {
  ...tableRowStyle,
  borderBottom: '1px solid #d9d9d9',
};

export const tableCellLabelStyle: CSSProperties = {
  padding: '12px 16px',
  backgroundColor: '#fafafa',
  fontWeight: 500,
  fontSize: 14,
};

export const tableCellValueStyle: CSSProperties = {
  padding: '12px 16px',
  backgroundColor: '#fff',
  fontSize: 14,
};

export const tableCellInputStyle: CSSProperties = {
  ...tableCellValueStyle,
};

export const tableCellHighlightStyle: CSSProperties = {
  ...tableCellValueStyle,
  fontWeight: 600,
  color: '#1890ff',
};

export const resumoGridStyle: CSSProperties = {
  border: '2px solid #1890ff',
  borderRadius: 8,
  overflow: 'hidden',
};

export const resumoRowStyle: CSSProperties = {
  ...tableRowStyle,
};

export const resumoRowWithBorderStyle: CSSProperties = {
  ...resumoRowStyle,
  borderBottom: '1px solid #d9d9d9',
};

export const resumoCellLabelStyle: CSSProperties = {
  padding: '16px',
  backgroundColor: '#fafafa',
  fontWeight: 600,
  fontSize: 15,
};

export const resumoCellValueStyle: CSSProperties = {
  padding: '16px',
  backgroundColor: '#fff',
  fontSize: 18,
  fontWeight: 700,
  color: '#1890ff',
};

export const resumoCellValueHighlightStyle: CSSProperties = {
  padding: '16px',
  backgroundColor: '#e6f7ff',
  fontSize: 20,
  fontWeight: 700,
  color: '#0050b3',
};

export const sectionTitleStyle: CSSProperties = {
  fontSize: 16,
  fontWeight: 600,
  marginBottom: 12,
  color: '#262626',
};

// Styles for AreaNaoAverbadaSection
export const switchContainerStyle: CSSProperties = {
  display: 'flex',
  gap: 12,
  marginBottom: 12,
};

export const switchTitleStyle: CSSProperties = {
  fontSize: 14,
  fontWeight: 500,
  margin: 0,
  color: '#262626',
};

export const naoAverbadaContainerStyle: CSSProperties = {
  border: '1px solid #d9d9d9',
  borderRadius: 8,
  overflow: 'hidden',
};

export const naoAverbadaRowStyle: CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
};

export const naoAverbadaRowWithBorderStyle: CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  borderBottom: '1px solid #d9d9d9',
};

export const naoAverbadaLabelStyle: CSSProperties = {
  padding: '12px 16px',
  backgroundColor: '#fafafa',
  fontWeight: 500,
  fontSize: 14,
};

export const naoAverbadaValueStyle: CSSProperties = {
  padding: '12px 16px',
  backgroundColor: '#fff',
  fontSize: 14,
};

export const naoAverbadaValueBoldStyle: CSSProperties = {
  padding: '12px 16px',
  backgroundColor: '#fff',
  fontSize: 14,
  fontWeight: 600,
  color: '#1890ff',
};

export const inputStyle: CSSProperties = {
  width: '100%',
};

// Additional styles for other components
export const classificationContainerStyle: CSSProperties = {
  display: 'grid',
  gridTemplateColumns: '1fr 1fr',
  gap: 16,
  marginBottom: 24,
};

export const selectStyle: CSSProperties = {
  width: '100%',
};

export const sectionContainerStyle: CSSProperties = {
  marginBottom: 24,
};

export const valorParcialStyle: CSSProperties = {
  fontWeight: 600,
  color: '#1890ff',
};

export const resumoTitleStyle: CSSProperties = {
  fontSize: 16,
  fontWeight: 600,
  marginBottom: 12,
  color: '#262626',
};

export const resumoContainerStyle: CSSProperties = {
  border: '2px solid #1890ff',
  borderRadius: 8,
  overflow: 'hidden',
};

export const resumoLabelStyle: CSSProperties = {
  padding: '16px',
  backgroundColor: '#fafafa',
  fontWeight: 600,
  fontSize: 15,
};

export const resumoValueAverbadaStyle: CSSProperties = {
  padding: '16px',
  backgroundColor: '#fff',
  fontSize: 18,
  fontWeight: 700,
  color: '#1890ff',
};

export const resumoValueNaoAverbadaStyle: CSSProperties = {
  padding: '16px',
  backgroundColor: '#e6f7ff',
  fontSize: 20,
  fontWeight: 700,
  color: '#0050b3',
};

export const validationContainerStyle: CSSProperties = {
  marginBottom: 16,
};

export const alertStyle: CSSProperties = {
  marginBottom: 8,
};
